// ── 상품 관리: 손님 테넌트 분류 머리줄 (2026-10-26 미남님 결정 a) ─────────────────────
// 손님 테넌트는 분류를 상품마다 직접 적어서(카테고리 표 없음) 묶음 이름을 한 번에 바꾸는 방법이 없었다.
//   [이름 고치기] = 그 테넌트 상품의 그 분류 + 회사에 붙이기(일일콜 분류) + 미팅지도 마커 글자·색을 한 번에.
//   [비우기] = 그 분류 상품을 미분류로(회사에 붙이기에 쓰이는 분류면 서버가 막고 안내 — 결정 1-가).
//   서버 POST /api/admin/ticket-types/category-change (services/tm/ticketType.tenantCategories.js).
//   운영사 카테고리 머리줄(CategoryHeaderRow)은 그대로 — 이 줄은 freeCategory(손님 테넌트) 화면에서만 쓴다.
import React, { useState } from 'react';
import { SquarePen, Eraser } from 'lucide-react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';
import { catHead, iconBtnIcon, deleteBtnIcon, input, addBtn } from './productStyles';

const URL = '/api/admin/ticket-types/category-change';

export function TenantCategoryHeaderRow({ name, count, onChanged }) {
  const { showToast } = useToast();
  const [editing, setEditing] = useState(false);
  const [newName, setNewName] = useState(name);
  const [confirming, setConfirming] = useState(false);
  const [saving, setSaving] = useState(false);

  async function send(body, done) {
    setSaving(true);
    const r = await apiClient.post(URL, body);
    setSaving(false);
    if (!r.ok) { showToast(r.data?.message || '바꾸지 못했어요.', 'error'); return; }
    const d = r.data?.data || {};
    showToast(done(d), 'success');
    setEditing(false);
    setConfirming(false);
    onChanged?.();
  }

  function rename() {
    const to = newName.trim();
    if (!to || to === name) { setEditing(false); setNewName(name); return; }
    send({ from: name, to }, (d) => [
      `'${name}' → '${to}': 상품 ${d.products}개`,
      d.matches ? `회사에 붙이기 ${d.matches}곳` : '',
      d.marker ? '마커 설정도 옮김' : '',
      d.merged ? `기존 '${to}'와 합쳤어요` : '',
    ].filter(Boolean).join(' · '));
  }

  function clear() {
    send({ from: name, clear: true }, (d) => `'${name}' 분류를 비웠어요: 상품 ${d.products}개가 미분류로 갔어요.`);
  }

  if (editing) {
    return (
      <div style={catHead}>
        <input autoFocus style={{ ...input, width: 160, fontSize: 12 }} value={newName} maxLength={50}
          onChange={(e) => setNewName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') rename(); if (e.key === 'Escape') { setEditing(false); setNewName(name); } }} />
        <button style={{ ...addBtn, padding: '4px 10px', fontSize: 12 }} onClick={rename} disabled={saving}>저장</button>
        <button style={{ ...iconBtnIcon, padding: '4px 8px', fontSize: 12 }} onClick={() => { setEditing(false); setNewName(name); }}>취소</button>
        <span style={{ fontSize: 11, fontWeight: 500, color: 'var(--text-muted)' }}>상품 {count}개 · 회사에 붙이기·마커 설정도 같이 바뀌어요</span>
      </div>
    );
  }
  return (
    <div style={catHead}>
      {name}
      <span style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        {confirming ? (
          <>
            <span style={{ fontSize: 11 }}>상품 {count}개를 미분류로 돌릴까요?</span>
            <button style={{ ...addBtn, padding: '4px 10px', fontSize: 12 }} onClick={clear} disabled={saving}>확인</button>
            <button style={{ ...iconBtnIcon, padding: '4px 8px', fontSize: 12 }} onClick={() => setConfirming(false)}>취소</button>
          </>
        ) : (
          <>
            <button style={iconBtnIcon} title="분류 이름 고치기(이 분류 상품 전부)" aria-label="분류 이름 고치기"
              onClick={() => { setNewName(name); setEditing(true); }}>
              <SquarePen size={14} />
            </button>
            <button style={deleteBtnIcon} title="분류 비우기(상품은 미분류로)" aria-label="분류 비우기"
              onClick={() => setConfirming(true)}>
              <Eraser size={14} />
            </button>
          </>
        )}
      </span>
    </div>
  );
}
